import { C } from "../../theme/tokens";

/* Single bordered row split into blocks by a hairline divider,
   matching the reference "ledger" motif shared with the balance
   panel above it — replaces two separate floating tiles (the old
   StatTile) with one continuous strip. */
export function StatsLedger({ winrate, winrateLabel, totalSignals, totalLabel }) {
  return (
    <div style={{ display: "flex", border: `1px solid ${C.hairline}`, background: C.panel1 }}>
      <StatBlock value={`${winrate}%`} label={winrateLabel}>
        <Sparkline />
      </StatBlock>
      <StatBlock value={totalSignals} label={totalLabel} bordered />
    </div>
  );
}

function StatBlock({ value, label, children, bordered }) {
  return (
    <div
      style={{
        flex: 1,
        padding: "16px 18px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
        borderLeft: bordered ? `1px solid ${C.hairline}` : "none",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontWeight: 600,
            fontSize: 24,
            color: C.primary,
          }}
        >
          {value}
        </span>
        {children}
      </div>
      <div style={{ fontSize: 11.5, color: C.mutedB }}>{label}</div>
    </div>
  );
}

function Sparkline() {
  return (
    <svg width="34" height="16" viewBox="0 0 34 16" fill="none" style={{ opacity: 0.85 }}>
      <polyline
        points="0,13 6,10 12,11 18,5 24,6 34,1"
        stroke={C.greenBright}
        strokeWidth="1.6"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
